import React, { ReactElement, useState } from 'react';
import Image, { StaticImageData } from 'next/image';
import { classNames } from 'lib/util';

interface ImageTabContents {
  image: StaticImageData;
  caption: string;
}

export default function ImageTabs({
  images,
}: {
  images: ImageTabContents[];
}): ReactElement {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <div className="max-w-max border">
      <nav className="flex flex-col sm:flex-row mb-2">
        {images.map((image, index) => (
          <button
            key={index}
            className={classNames(
              'text-base text-gray-600 py-2 sm:py-4 px-4 block hover:text-blue-500 focus:outline-none',
              selectedTab === index &&
                'text-blue-500 border-b-2 font-medium border-blue-500'
            )}
            onClick={() => setSelectedTab(index)}
          >
            {image.caption}
          </button>
        ))}
      </nav>
      {images.map((image, index) => (
        <div
          key={index}
          className={classNames(
            'flex justify-center',
            selectedTab !== index && 'hidden'
          )}
        >
          <Image
            src={image.image}
            alt={image.caption}
            quality={100}
            placeholder="blur"
          />
        </div>
      ))}
    </div>
  );
}
